<template>
  <p class="outcomes-summary">
    <span
      v-for="{ outcome, emoji, label, count } in counts"
      :key="outcome"
      class="outcome-count"
    >
      <span aria-hidden="true">{{ emoji }} {{ count }}</span>
      <span class="visually-hidden">{{ label }} : {{ count }}</span>
    </span>
  </p>
</template>

<script setup>
import { computed } from "vue";

import { OUTCOME_EMOJIS, OUTCOME_LABELS, OUTCOMES_ORDER } from "@/constants/outcomes";

const props = defineProps({
  entries: {
    type: Array,
    required: true,
  },
});

/**
 * Nombre de confrontations par issue, dans l'ordre d'affichage
 * Une issue jamais rencontrée est affichée à zéro plutôt qu'omise,
 * pour que le bilan garde la même forme d'une ligue à l'autre
 */
const counts = computed(() => {
  return OUTCOMES_ORDER.map((outcome) => ({
    outcome,
    emoji: OUTCOME_EMOJIS[outcome],
    label: OUTCOME_LABELS[outcome],
    count: props.entries.filter((entry) => entry.outcome === outcome).length,
  }));
});
</script>

<style lang="scss" scoped>
.outcomes-summary {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 15px;
  font-size: 1.1rem;
}

.outcome-count {
  white-space: nowrap;
}
</style>